const sv = require('./resources/sv.json');

export default {
    messages: sv,
    formats: {
        date: {
            short: {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            },
        },
        number: {
            price: {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};
